// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"socialMedia-module--Wrapper--1FYq_","Icons":"socialMedia-module--Icons--M7mnN","Icon":"socialMedia-module--Icon--2JxFU"};